import React from "react";
import Image from "next/image";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styles from "../services/ServicesSections.module.scss";






export default function SectionOffice() {
  const classes = styles;
  return (
    <div className={classes.office}>
 
      <GridContainer spacing = {4}>

      <GridItem md={6} sm={6}>
        <div  className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}> 
            <Image
            className = {classes.rounded}
              quality = {100}
            layout = "responsive"
            width = {540}
            height = {360}
        
            src="/img/photo-gallery/mk-6.jpg"
            alt="office5"
          />
          </div>
          
        </GridItem>

        <GridItem md={6} sm={6}>
        <div  className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}> 
            <Image
            className = {classes.rounded}
              quality = {100}
            layout = "responsive"
            width = {540}
            height = {360}
        
            src="/img/photo-gallery/mk-9.jpg"
            alt="office5"
          />
          </div>
          
        </GridItem>

      <GridItem md={6} sm={6}>
          <div className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}> 
          <Image
          className = {classes.rounded}
            className = {classes.rounded}
            quality = {100}
            layout = "responsive"
            width = {350}
            height = {320}
            src="/img/photo-gallery/mk-11.jpg"
            
            alt="office1"
          />
          </div>          
        </GridItem>
        
        <GridItem md={6} sm={6}>
        <div  className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}> 
          <Image
          className = {classes.rounded}
            quality = {100}
            layout = "responsive"
            width = {350}
            height = {350}
            
            src="/img/photo-gallery/scott-natgood.jpg"
            alt="office3"
          />
          </div>
          
        </GridItem>
        
        <GridItem md={6} sm={6}>
        <div  className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}> 
            <Image
            className = {classes.rounded}
              quality = {100}
            layout = "responsive"
            width = {540}
            height = {383}
           
            src="/img/photo-gallery/mk-3.jpg"
            alt="office4"
          />
          </div>

        </GridItem>
        <GridItem md={6} sm={6}>
        <div  className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}> 
            <Image
            className = {classes.rounded}
              quality = {100}
            layout = "responsive"
            width = {540}
            height = {360}
        
            src="/img/photo-gallery/mk-4.jpg"
            alt="office5"
          />
          </div>
          
        </GridItem>





        <GridItem md={6} sm={6}>
        <div  className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}> 
            <Image
            className = {classes.rounded}
              quality = {100}
            layout = "responsive"
            width = {540}
            height = {360}
        
            src="/img/photo-gallery/mk-14.jpg"
            alt="office5"
          />
          </div>
          
        </GridItem>
        <GridItem md={6} sm={6}>
        <div  className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}> 
          <Image
          className = {classes.rounded}
            quality = {100}
            layout = "responsive"
            width = {350}
            height = {263}
            
            src="/img/photo-gallery/pg2.jpg"
            alt="office2"
          />
          </div>
          
        </GridItem>

        
      
      </GridContainer>
    </div>
  );
}
